module.exports = __webpack_public_path__ + "static/media/4ODA6.cf1b86c3.jpg";